import React from "react";
import IntelligenceWorkspaceShell from "./IntelligenceWorkspaceShell";

export default function ExecutiveActions({ children }) {
  return (
    <IntelligenceWorkspaceShell
      workspaceKey="executions"
      eyebrow="Leadership execution"
      title="Executive Actions"
      description="Resume, review and verify operational improvement work."
    >
      {children}
    </IntelligenceWorkspaceShell>
  );
}
